import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { UserDetailsModel, UserModel } from '../../../models/user';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'app/components/utils/Utils';
import { OperatorFilterEnum } from 'app/models/filter-model';
import { MatTableDataSource } from '@angular/material/table';
import { PageModel } from 'app/models/page-model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { passwordStrengthValidator } from 'app/validations/password-strength.validator';
import { Log } from 'app/core/logging/log';



@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.page.html',
  styleUrls: ['./admin-user.page.scss'],
})
export class AdminUserPage implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<UserModel>;
  users: PageModel<UserModel>;
  totalElements = 0;
  pageSize = 10;
  pageIndex = 0;

  fieldFilters: any[] = [];
  displayedColumns: string[] = ['name', 'username', 'email', 'roles'];


  constructor(    
    private dialog: MatDialog,
    private restService: RestService,
    private appService: AppService) {
      this.users = {
        content: [],
        pageNumber: 0,
        pageSize: this.pageSize,
        totalPages: 0,
        totalElements: 0,
        first: true,
        last: true
      };
    }

  ngOnInit() {

    this.fieldFilters.push({
      name: 'name',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'name'
    });
    this.fieldFilters.push({
      name: 'username	',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'username'
    });
    this.fieldFilters.push({
      name: 'email',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'Email'
    });
    this.fieldFilters.push({
      name: 'roles',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_LOCKER', 'ROLE_INSTALL', 'ROLE_MANAGER', 'ROLE_COMMISSION_AGENT'],
      label: 'roles'
    });
    this.fieldFilters.push({
      name: 'cardId',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'cardId'
    });

    this.searchUsers(true);
  }

  openDetails(user: UserModel) {
    console.log('openDetails', user);
    let dialogRef = this.dialog.open(UserModalContent, {
      panelClass: 'responsive-dialog',
      data: { user: user }
    });
    dialogRef.afterClosed().subscribe((data: { updated: boolean }) => data?.updated && this.searchUsers());
  }
    
  openNewUser() {
    let user = {
        id: null,
        name: '',
        username: '',
        email: '',
        roles: [],
        createdAt: undefined,
        updatedAt: undefined
      }
    this.openDetails(Object.assign({}, user));
  }
  

  mapAsFilters(fieldFilters:any[]){
      let filters = [];
      let map = [];
      map['date'] = OperatorFilterEnum.BETWEEN;
      map['datetime'] = OperatorFilterEnum.BETWEEN;
      map['time'] = OperatorFilterEnum.BETWEEN;
      map['text'] = OperatorFilterEnum.LIKE;
      map['select'] = OperatorFilterEnum.EQUALS;
      map['number'] = OperatorFilterEnum.LIKE;
  
      for(let fieldFilter of fieldFilters){
        if((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)){
          filters.push({
            field: fieldFilter.name,
            operator: map[fieldFilter.type],
            value: fieldFilter.value,
            values: fieldFilter.values
          }); 
        }
      }
      return Utils.generateFilters(filters);
    }
  
  searchUsers(resetPage: boolean = false) {
    if (resetPage) {
      this.pageIndex = 0;
      if (this.paginator) {
        this.paginator.firstPage();
      }
    }

    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.pageIndex + '&size=' + this.pageSize;

    this.restService.searchUsers(filters + sort + pageSize).subscribe((result:PageModel<UserModel>) => {
      console.log('searchUsers', result);
      this.users = result;
      this.dataSource.data = result.content;
      this.totalElements = result.totalElements;
      this.pageSize = result.pageSize;
      this.pageIndex = result.pageNumber;
    });
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.searchUsers();
  }


}



@Component({
  selector: 'app-user-modal-content',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss']
})
export class UserModalContent {

  user: UserDetailsModel;
  isNew: boolean = false;
  userForm: FormGroup;
  customerForm: FormGroup;

  constructor(
              private fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: { user: UserModel },
              public dialogRef: MatDialogRef<UserModalContent>,
              private restService: RestService,
              public appService: AppService
            ) {

              }

  ngOnInit() {

    this.isNew = this.data.user.id==null ? true : false;

    this.userForm = this.fb.group({
      id: [],
      name: ['', [Validators.required, Validators.minLength(4)]],
      username: ['', [Validators.required, Validators.minLength(4)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required,
                     Validators.minLength(6),
                     Validators.maxLength(20),
                     passwordStrengthValidator()
                    ]],
      roles: ['', [Validators.required]]
    });

    this.isNew ? this.password?.enable() : this.password?.disable();

    this.customerForm = this.fb.group({
      id: [],
      companyName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', Validators.email],
      phone: [],
      typeCardId: ['', Validators.required],
      cardId: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      zipCode: ['', Validators.required],
      userId: []
    });

    if(!this.isNew){
      this.restService.getUser(this.data.user.id).subscribe(result => {
        console.log('getUser', result);
        this.user = result;
        this.setForm();
      });
    }else{
      this.customerForm.disable();
    }

  }

  get password() { return this.userForm.get('password')!; }
  get form(){ 
    let userToSave = this.userForm.value;
    let customerToSave = this.customerForm.value;
    userToSave.userFiscalData = customerToSave;
    userToSave.deleteCompanyData = this.deleteCompanyData;
    return userToSave;
  }
  get deleteCompanyData(): boolean { return this.customerForm.disabled && this.user?.userFiscalData != null; }

  setForm(){
    this.setUserForm();
    this.setCustomerForm(this.user.userFiscalData ? true : false);
  }

  setUserForm(){
    this.userForm.patchValue({
      id: this.user.id,
      name: this.user.name,
      username: this.user.username,
      email: this.user.email,
      password: '',
      roles: this.user.roles,
      deleteCompanyData: this.deleteCompanyData
    });
  }
  
  setCustomerForm(enabled:boolean){
    if(enabled){
      this.customerForm.enable();
      if(this.user?.userFiscalData){
        this.customerForm.patchValue({
          id: this.user.userFiscalData.id,
          companyName: this.user.userFiscalData.companyName,
          address: this.user.userFiscalData.address,
          email: this.user.userFiscalData.email,
          phone: this.user.userFiscalData.phone,
          typeCardId: this.user.userFiscalData.typeCardId,
          cardId: this.user.userFiscalData.cardId,
          city: this.user.userFiscalData.city,
          country: this.user.userFiscalData.country,
          zipCode: this.user.userFiscalData.zipCode,
          userId: this.user.userFiscalData.userId,
        });
      }
    }else{
      this.customerForm.reset();
      this.customerForm.disable();
    }
  }

  toggleCustomerForm(checked: boolean) {
   console.log('toggleCustomerForm', checked);
   this.setCustomerForm(checked);
  }

  disabledPassword(){
    if(this.password?.disabled){
      this.password?.enable();
    }else{
      this.password?.disable();
      this.password?.setValue('');
    }
  }

  save(){
    console.log('Form Values:', this.form);
    if(!this.userForm.valid){
      this.userForm.markAllAsTouched();
      return;
    }

    if(this.customerForm.enabled && !this.customerForm.valid){
      this.customerForm.markAllAsTouched();
      return;
    }

    if(this.isNew){
      this.createUser();
    }else{
      this.updateUser();
    }
  }

  delete(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.deleteUser(this.user.id).subscribe(result => {
      console.log('deleteUser', result);
      this.dialogRef.close({"updated": true});
    });
  }
  
  close(){
    this.dialogRef.close({"updated": false});
  }
  
  createUser(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.postUser(this.form).subscribe(result => {
      console.log('postUsers', result);
      this.dialogRef.close({"updated": true});
    });
  }

  updateUser(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.putUser(this.form).subscribe(result => {
      console.log('putUsers', result);
      this.dialogRef.close({"updated": true});
    });
  } 
  
}
